import React from "react";
import targetProcessLogo from "../../assets/images/target-process-logo.png";
import BootstrapTooltip from "../bootstrap-tooltip/bootstrap-tooltip";
import { MotherTicketTagResponseModel } from "../../swagger-clients/s365-admin-panel-clients.service";

type TargetProcessLinkProps = {
    targetProcesMotherTicketId: number;
    ticketName?: string;
    nameAsTooltip?: boolean,
    totalUsersCount?: number;
    tags?: MotherTicketTagResponseModel[];
    style?: React.CSSProperties;
    className?: string;
}

export const TargetProcessLink: React.FC<TargetProcessLinkProps> = (props) => {


    return <div className={props.className}>
        <a href={`https://capitalgain.tpondemand.com/entity/${props.targetProcesMotherTicketId}`}
            target="_blank"
            onClick={(ev) => ev.stopPropagation()}
            style={{ display: "inline-flex", ...props.style }}
        >
            <img height={"20px"} src={targetProcessLogo} alt="Target process logo" />
            <span className="ml-2">
                {!props.nameAsTooltip && (!!props.ticketName ? props.ticketName : `#${props.targetProcesMotherTicketId}`)}
                {props.nameAsTooltip && <BootstrapTooltip tooltipText={props.ticketName}><span>{props.targetProcesMotherTicketId}</span></BootstrapTooltip>}
            </span>
        </a>
        {props.totalUsersCount !== undefined && <span className="ml-1">({props.totalUsersCount})</span>}
        {!!props.tags && props.tags.filter(x => !!x.showWithName).map((tag) => {
            return <BootstrapTooltip tooltipText={tag.name}>
                <span className="ml-2"><i className={tag.icon} style={{ color: "black" }}></i></span>
            </BootstrapTooltip>
        })}
    </div>
}